import { Button } from "../ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem } from "../ui/dropdown-menu";
import { DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu";
import { ChevronDown, Edit } from "lucide-react";
import { FC, MouseEventHandler, ReactNode, useId } from "react";
import { Separator } from "../ui/separator";
import {
  OptimizedTooltip,
  OptimizedTooltipContent,
  OptimizedTooltipTrigger,
} from "../ui/optimized-tooltip";

export type BatchActionMenuItem = {
  label: ReactNode;
  disabled?: boolean;
  disabledTooltip?: ReactNode;
  onClick: MouseEventHandler<HTMLDivElement>;
};

interface BatchActionMenuProps {
  isDisabled?: boolean;
  items: BatchActionMenuItem[];
  /** 複寫觸發按鈕內容；未提供時顯示預設的「批次動作」 */
  children?: ReactNode;
}

export const BatchActionMenu: FC<BatchActionMenuProps> = ({ isDisabled, items, children }) => {
  const buttonId = useId();
  return (
    <>
      <DropdownMenu>
        {/* Trigger */}
        <DropdownMenuTrigger asChild>
          <Button
            id={buttonId}
            disabled={isDisabled}
            variant="dropdownPrimary"
            size="dropdownPrimary"
          >
            {children ?? (
              <div className="flex items-center justify-center">
                <Edit />
                <p className="ml-3 text-nowrap">批次動作</p>
                <ChevronDown className="ml-3" />
              </div>
            )}
          </Button>
        </DropdownMenuTrigger>

        {/* Content */}
        <DropdownMenuContent className="border-primary-200 p-0">
          {items?.map((item, index) => (
            <div key={index} className="group">
              <OptimizedTooltip side="left" hidden={!item.disabled || !item.disabledTooltip}>
                <OptimizedTooltipTrigger>
                  <div className="px-1 py-0.5">
                    <DropdownMenuItem
                      className="grid place-content-center whitespace-nowrap"
                      key={index}
                      ref={(ref) => {
                        if (ref) {
                          const button = document.getElementById(buttonId);
                          const rect = button?.getBoundingClientRect();
                          if (rect) {
                            ref.style.width = `${rect.width}px`;
                          }
                        }
                      }}
                      disabled={item.disabled}
                      onClick={item.onClick}
                    >
                      {item.label}
                    </DropdownMenuItem>
                  </div>
                </OptimizedTooltipTrigger>
                <OptimizedTooltipContent className="text-xs">
                  {item.disabledTooltip}
                </OptimizedTooltipContent>
              </OptimizedTooltip>

              <Separator className="bg-primary-100 group-last:hidden" />
            </div>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
};
